import React from 'react';
import logo from './logo.svg';
import './App.css';

import { connect } from 'react-redux';
import { setValor } from './actions';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Portal from './containers/dash/Portal';


function App(props) {
  const renderDash = () => <Portal />;

  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/" component={renderDash} />
        </Switch>
      </div>
    </Router>
  );
}

const mapDispatchToProps = dispatch => ({
  setValor: value => dispatch(setValor(value)),
  //setAuth: value => dispatch(setAuth(value))
});

const mapStateToProps = state => ({
  valorProps: state.valor,
  authProps: state.auth,
});

const appRedux = connect(mapStateToProps, mapDispatchToProps)(App)
export default appRedux;
